import {
  competition,
  functions
} from "@/main.js";
import firebase from "firebase";
import {
  v4 as uuid
} from 'uuid';

export const currentUser = () => firebase.auth().currentUser;
const DEFAULT_PASSWORD = 'nopass';

export const requiresAuth = () => {
  const auth = firebase.auth();
  // if (auth.currentUser)
  //   console.log(auth.currentUser.email, auth.currentUser.displayName);
  return !firebase.auth().currentUser;
};

export const signInOrRegister = async (email, displayName, referralId) => {
  const resp = await functions.httpsCallable("createUserIfDoesntExist")({
    email,
    displayName,
    referralId: referralId || "",
    competition
  });
  const {
    user
  } = await firebase
    .auth()
    .signInWithEmailAndPassword(email, "nopass");
  // console.log("signed in with ", user.email, user.displayName);
};

export const generateUserUid = () => {
  return uuid().replace(/-/gi, "");
}

export const createTempUser = async (email, displayName, referralId, uid) => {
  // console.log("Temp user uid: ", uid);
  await functions.httpsCallable('createTempUser')({
    email,
    displayName,
    referralId: referralId || "",
    competition,
    uid: uid
  });
}

export const signInWithEmailAndPassword = async (email) => {
  const {
    user
  } = await firebase
    .auth()
    .signInWithEmailAndPassword(email, DEFAULT_PASSWORD);
  // console.log("signed in with ", user.email, user.displayName);
}

export const changeEmailAndDisplayName = async (email, displayName) => {
  const currentUser = firebase.auth().currentUser;
  const credential = firebase.auth.EmailAuthProvider.credential(currentUser.email, DEFAULT_PASSWORD);
  await currentUser.reauthenticateAndRetrieveDataWithCredential(credential);
  await functions.httpsCallable('changeEmailAndDisplayName')({
    newEmail: email,
    newDisplayName: displayName,
    competition: competition
  });
  await signInWithEmailAndPassword(email);
}